import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MuiTooltip from '@material-ui/core/Tooltip';

const useStylesBootstrap = makeStyles(theme => ({
  arrow: {
    color: theme.palette.common.black,
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
  },
}));

function BootstrapTooltip(props) {
  const classes = useStylesBootstrap();

  return <MuiTooltip arrow classes={classes} {...props} placement={props?.placement} />;
}

export default function CommonTooltip(props) {
  const { placement = 'top', content = '', style = {}, className = '' } = props;
  return (
    <BootstrapTooltip style={style} className={className} placement={placement} title={content}>
      <b>{!content ? <span>{props.children}</span> : props.children}</b>
    </BootstrapTooltip>
  );
}
